import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { ChronologyReviewStatus } from "~/api/model";
import { Badge, BadgeProps } from "~/components/ui/badge";

interface ChronologyReviewStatusBadgeProps {
  status: ChronologyReviewStatus;
}

const STATUS_CONFIG: Record<
  ChronologyReviewStatus,
  { variant: BadgeProps["variant"]; labelId: string }
> = {
  [ChronologyReviewStatus.CONFIRMED]: {
    variant: "success",
    labelId: "chronology.status.confirmed",
  },
  [ChronologyReviewStatus.CORRECTED]: {
    variant: "secondary",
    labelId: "chronology.status.corrected",
  },
  [ChronologyReviewStatus.REJECTED]: {
    variant: "destructive",
    labelId: "chronology.status.rejected",
  },
  [ChronologyReviewStatus.UNREVIEWED]: {
    variant: "outline",
    labelId: "chronology.status.unreviewed",
  },
};

/**
 * Shows the review status of a chronology event. Unreviewed events show no
 * badge to keep the list quiet — the badge appears once a reviewer acts.
 */
export const ChronologyReviewStatusBadge: FC<
  ChronologyReviewStatusBadgeProps
> = ({ status }) => {
  if (status === ChronologyReviewStatus.UNREVIEWED) return null;

  const { variant, labelId } = STATUS_CONFIG[status];

  return (
    <Badge variant={variant} className="pointer-events-none">
      <FormattedMessage id={labelId} />
    </Badge>
  );
};
